// Pages inside AppShell get the sidebar logo instead of the top Navbar.
const shouldRenderHeader = (pathname) => {
  const noHeaderRenderPaths = [
    "/provider",
    "/add-new-appointment",
    "/cancel-appointment",
    "/providerappointments",
    "/edit-appointment",
    "/confirm-schedule",
    "/edit-observer",
    "/availability",
    "/collect-teacher-signature",
    "/view-teacher-signature",
    "/appointments",
    "/benefits-summary",
    "/documents",
    "/client-appointments",
  ];
  return !noHeaderRenderPaths.includes(pathname);
};

export { shouldRenderHeader };
